
define('template!imageSourcePickerView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="image-source-picker">\n  <div class="isp-tabs">\n    <button type="button" class="isp-tab" data-key="upload">\n      ' +
((__t = ( _.i18n('imageSourcePicker.upload', null, 'Upload') )) == null ? '' : __t) +
'\n    </button>\n    ';
 _.each(sources, function(s){ ;
__p += '\n      <button type="button" class="isp-tab" data-key="' +
__e( s.key ) +
'">' +
__e( s.label ) +
'</button>\n    ';
 }); ;
__p += '\n  </div>\n\n  <div class="isp-body">\n    <div class="isp-panel"></div>\n  </div>\n\n  <div class="isp-footer">\n    <button type="button" class="btn btn-default isp-cancel">\n      ' +
((__t = ( _.i18n('common.cancel', null, 'Cancel') )) == null ? '' : __t) +
'\n    </button>\n  </div>\n\n  <input type="file" class="isp-upload-input" accept="image/*" style="display:none">\n</div>\n';

}
return __p
};});

